// Interfaces
import { IFormTextAreaProps } from './interfaces'

// Antd
import { Input } from 'antd'

// i18n
import { useTranslation } from 'react-i18next'

// Lodash
import omit from 'lodash/omit'

const FormTextArea = (props: IFormTextAreaProps) => {
  // Hook
  const { t } = useTranslation()

  return (
    <>
      {/* @ts-ignore: Unreachable code error */}
      <Input.TextArea
        {...omit(props, ['labelValue', 'renderLabel'])}
        className={`custom-input common ${props?.className}`}
        placeholder={t(props?.placeholder || '')}
        style={{ height: props?.style?.height || 100, ...props?.style }}
      />

      {props?.style?.display === 'none' ? (
        <p className="font-14 text-grey font-weight-400 w-56">{props?.labelValue || '-'}</p>
      ) : (
        <></>
      )}
    </>
  )
}

export { FormTextArea }
